<template lang="pug">
    .columns.is-multiline
      .column.is-6(v-for="(value, key) in item" v-if="key !== 'id'")
        .columns
          .column.is-4
            span.tag.is-black
              | {{ traducirKey (key) }}
          .column.is-8
            span(v-html="convertirValor(value)")
</template>

<script>
  export default {
    name: 'CardItems',
    props: {
      item: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        textos: [
          { id: 'anio_modelo', trad:'Modelo'},
          { id: 'antena_radio', trad:'Antena'},
          { id: 'aseguradora', trad:'Aseguradora'},
          { id: 'batea', trad:'Batea'},
          { id: 'birlos', trad:'Birlos'},
          { id: 'bolsa_herr', trad:'Bolsa Herr.'},
          { id: 'cables_corr', trad:'Cables p/Corr.'},
          { id: 'categoria', trad:'Categoria'},
          { id: 'cobertura', trad:'Cobertura'},
          { id: 'color', trad:'Color'},
          { id: 'control_ape', trad:'Control Apert.'},
          { id: 'cristales', trad:'Cristales'},
          { id: 'emblema_del', trad:'Emblema Del.'},
          { id: 'emblema_tras', trad:'Emblema Tras.'},
          { id: 'encendedor', trad:'Encendedor'},
          { id: 'espejoLD', trad:'Espejo Lat. D'},
          { id: 'espejoLI', trad:'Espejo Lat I.'},
          { id: 'espejo_int', trad:'Espejo Int.'},
          { id: 'estatus', trad:'Estatus'},
          { id: 'extintor', trad: 'Extintor'},
          { id: 'gasolina', trad: 'Gasolina'},
          { id: 'gato', trad: 'Gato'},
          { id: 'id', trad: 'ID'},
          { id: 'id_vehiculo', trad: 'ID SAP'},
          { id: 'limpiadores', trad: 'Limpiadores'},
          { id: 'llanta_refaccion', trad: 'Llanta Refacción'},
          { id: 'llave', trad: 'Llave'},
          { id: 'llave_cruz', trad: 'Llave Cruz'},
          { id: 'llave_tapComb', trad: 'Llave Tapón Comb.'},
          { id: 'manija_puerta', trad: 'Manija Puerta'},
          { id: 'manual', trad: 'Manual'},
          { id: 'marca', trad: 'Marca'},
          { id: 'modelo', trad: 'Modelo'},
          { id: 'nombre_responsiva', trad: 'Responsiva'},
          { id: 'numero_motor', trad: '# Motor'},
          { id: 'observaciones', trad: 'Observaciones'},
          { id: 'placas', trad: 'Placas'},
          { id: 'placasF', trad: 'Placas Fís.'},
          { id: 'poliza', trad: 'Póliza'},
          { id: 'polizaV', trad: 'Póliza Fís.'},
          { id: 'porta_placaD', trad: 'Porta Placa Del.'},
          { id: 'porta_placaT', trad: 'Porta Placa Treas'},
          { id: 'radio_estereo', trad: 'Radio Est.'},
          { id: 'reflejantes', trad: 'Reflejantes'},
          { id: 'serie', trad: 'Serie'},
          { id: 'tapetes', trad: 'Tapetes'},
          { id: 'tapon_aceite', trad: 'Tapón Aceite'},
          { id: 'tapon_gasolina', trad: 'Tapón Gasolina'},
          { id: 'tapon_radiador', trad: 'Tapón Radiador'},
          { id: 'tapon_rueda', trad: 'Tapón Rueda'},
          { id: 'tarjeta_circ', trad: 'Tarjeta Circ.'},
          { id: 'varilla_aceite', trad: 'Varilla Aceite'},
          { id: 'vencimiento', trad: 'Vencimiento'},
          { id: 'verificacion', trad: 'Verificacion'},
          { id: 'accesorios', trad: 'Accesorios'},
          { id: 'backpack', trad: 'Backpack'},
          { id: 'caja', trad: 'Caja'},
          { id: 'capacidad', trad: 'Capacidad'},
          { id: 'cargador', trad: 'Cargador'},
          { id: 'color', trad: 'Color'},
          { id: 'funda', trad: 'Funda'},
          { id: 'id_computo', trad: 'ID SAP'},
          { id: 'memoria', trad: 'Memoria'},
          { id: 'mouse', trad: 'Mouse'},
          { id: 'adaptadorSd', trad: 'Adaptador SD'},
          { id: 'audifonos', trad: 'Audífonos'},
          { id: 'caja', trad: 'Caja'},
          { id: 'capacidad', trad: 'Capacidad'},
          { id: 'cargador', trad: 'Cargador'},
          { id: 'color', trad: 'Color'},
          { id: 'id_telefono', trad: 'ID SAP'},
          { id: 'imei', trad: 'IMEI'},
          { id: 'min', trad: 'Min.'},
          { id: 'numero', trad: 'Número'},
          { id: 'plan', trad: 'Plan'},
          { id: 'protector', trad: 'Protector'},
          { id: 'serieSim', trad: 'Serie SIM'},
          { id: 'sim', trad: 'SIM'},
          { id: 'sms', trad: 'SMS'},
          { id: 'dispositivo', trad: 'Dispositivo'},
          { id: 'id_peaje', trad: 'ID SAP'},
          { id: 'id_combustible', trad: 'ID SAP'},
          { id: 'tarjeta', trad: 'Tarjeta'}
        ]
      }
    },
    methods: {
      traducirKey(key) {
        let keyStr = ''
        let textSel = this.textos.find( text => text.id === key)
        if ( typeof textSel === 'undefined') {
          keyStr = key
        } else {
          keyStr = textSel.trad
        }
        return keyStr
      },
      convertirValor(val) {
        console.log(val)
        let htmlSts = ''
        switch (val) {
          case 0:
            htmlSts = `<span class='icon'><i class="far fa-square"></i></span>`
            break
          case 1:
            htmlSts = `<span class='icon has-text-success'><i class="far fa-check-square"></i></span>`
            break
        
          default:
            htmlSts = val
            break
        }
        return htmlSts
      }
    },
  }
</script>

<style lang="scss" scoped>
  .column.is-3.reducido {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/CardItems.vue